/**
 * 26/09/09 商品購入の個数制限
 *
 * 商品メタフィールド custom.order_limit（購入数制限 / 整数）に値が入っている商品は、
 * カート内の同一商品の合計数量（全バリアント合算）を上限までに制限する。
 * 例) 上限 2 の商品なら「チョコ 2個」を入れた時点で「いちご味」も追加できない。
 * 値が空 or 0 の商品は無制限（従来どおり）。
 *
 * 素の JavaScript のみ。**判定の本体は Liquid 側（server-side）にある**。
 * このファイルは「ページが再描画されないまま状態が変わる場面」だけを補う。
 *
 * Liquid 側の実装:
 *   - snippets/product-form.liquid              商品ページ（カートに追加 / 今すぐ購入 / 数量）
 *   - snippets/cart-items.liquid                カート・ドロワー（数量の max と「+」ボタン）
 *   - snippets/custom-card-product.liquid       カードのクイック追加
 *   - snippets/custom-row-card-product.liquid   カードのクイック追加
 *   - snippets/modal-confirmation-script.liquid 確認モーダルの送信前チェック（orderLimitCanAdd）
 *
 * JS で補わないといけない箇所（すべて実コードで確認済み）:
 *   1. theme.min.js の _updateAddToCartButton() はバリアント変更時にカートに追加ボタンを
 *      DOM ごと差し替えるため、Liquid で付けた disabled が消える
 *   2. theme.min.js の _increaseQuantity() は input の max 属性を見ずに +1 する。
 *      数量欄は type="text" なので max はブラウザ側では効かない
 *   3. カート追加・ドロワーでの数量変更は Ajax なのでページが再描画されない。
 *      カートドロワーは cart 以外の全ページに描画されている（layout/theme.liquid）ので、
 *      そこで減らしたのにボタンが押せないまま、を防ぐ必要がある
 *   4. 確認モーダルは productForm.submit() を呼ぶ。ネイティブ送信なので
 *      submit イベントもボタンの disabled も迂回する
 *
 * 状態の優先順位は 売り切れ > 個数制限 > 通常。
 * 個数制限が触るのは「今まさに購入可能なボタン」だけで、
 * 塞いだものには data-order-limit-disabled の印を付けて所有関係を明示する。
 *
 * ■ 意図的に作り込んでいないこと
 * 並行 Ajax・通信断・正確なタイミングでの連打が絡む一瞬の窓では、上限を 1 個超えられる。
 * このプロジェクトでは「テーマ実装なので Cart API 直叩きは防げない」を仕様として受容しており、
 * それらの競合は直叩きより成立条件が厳しい。厳密な強制が要るなら Shopify Functions
 * （Cart validation）が必要で、テーマ側の作り込みで詰めるべき問題ではない。
 */

(function () {
  'use strict';

  var PRODUCT_FORM_SELECTOR = '.ProductForm[data-order-limit]';
  var QUICK_ADD_SELECTOR = '.quick-add[data-order-limit]';
  var QUANTITY_INPUT_SELECTOR = '.QuantitySelector__CurrentQuantity';

  // dawn-product-form.js は POST を開始する前に aria-disabled を false に戻すため、
  // 連打すると /cart/add が並行して飛ぶ。直前の送信から少しの間は 2 回目を受け付けない。
  var DOUBLE_SUBMIT_WINDOW = 2000;

  var refreshTimer = null;

  function toInt(value) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? 0 : parsed;
  }

  function limitReachedMessage() {
    return (window.languages && window.languages.productFormOrderLimitReached) || 'これ以上購入できません';
  }

  /**
   * 個数制限以外の理由で押せなくなっているボタンか。
   * dawn-product-form.js は API エラー時に aria-disabled="true" を付け、
   * .finally() でも（this.error のため）外さないので、これも他者所有として扱う。
   */
  function isDisabledByOthers(button) {
    return button.hasAttribute('disabled') || button.getAttribute('aria-disabled') === 'true';
  }

  /**
   * 全 SKU 分の上限とカート内数量。Liquid が出した JSON を一度だけ読んで持つ。
   * { "<variant id>": { limit: 1, inCart: 0 }, ... }
   */
  function variantDataOf(container) {
    if (container.__orderLimitData !== undefined) { return container.__orderLimitData; }

    var json = container.querySelector('[data-order-limit-json]');

    try {
      container.__orderLimitData = json ? JSON.parse(json.textContent) : null;
    } catch (error) {
      container.__orderLimitData = null;
    }

    return container.__orderLimitData;
  }

  /**
   * 今選ばれている SKU の ID。
   * 商品ページは variant:changed のたびに控えた値、カードは id フィールドの値を使う。
   */
  function selectedVariantId(container) {
    if (container.__orderLimitVariantId) { return container.__orderLimitVariantId; }

    var field = container.querySelector('select[name="id"], input[name="id"]');
    var fromField = field ? toInt(field.value) : 0;

    return fromField > 0 ? fromField : toInt(container.getAttribute('data-order-limit-variant-id'));
  }

  /**
   * 選択中の SKU の上限・カート内数量をコンテナの属性へ写す。
   * 以降の処理はこの 2 つの属性だけを見ればよくなる（SKU 単位である事情を閉じ込める）。
   */
  function syncSelectedVariant(container) {
    var data = variantDataOf(container);

    if (!data) { return; }

    var entry = data[String(selectedVariantId(container))];

    container.setAttribute('data-order-limit', String(entry ? toInt(entry.limit) : 0));
    container.setAttribute('data-order-limit-in-cart', String(entry ? toInt(entry.inCart) : 0));
  }

  /**
   * 残り購入可能数。制限なしの SKU は null を返す。
   */
  function remainingOf(element) {
    var limit = toInt(element.getAttribute('data-order-limit'));

    if (limit <= 0) { return null; }
    return Math.max(limit - toInt(element.getAttribute('data-order-limit-in-cart')), 0);
  }

  /**
   * このフォーム / コンテナから、今カートに追加してよいか。
   * 確認モーダルのネイティブ送信からも呼ばれる（window.orderLimitCanAdd）。
   */
  function canAdd(element) {
    if (!element) { return true; }

    var container = element.closest(QUICK_ADD_SELECTOR) ||
                    (element.matches(PRODUCT_FORM_SELECTOR) ? element : element.closest(PRODUCT_FORM_SELECTOR));

    if (!container) { return true; }

    syncSelectedVariant(container);

    var remaining = remainingOf(container);

    return remaining === null || remaining > 0;
  }

  /**
   * カート内数量を先に進めておく。
   * 追加成功から /cart.js の応答が返るまでの間、古い残数で続けて追加されるのを防ぐ。
   * 値は次の再取得で実測値に上書きされる。
   */
  function bumpInCart(variantId, quantity) {
    var elements = document.querySelectorAll(PRODUCT_FORM_SELECTOR + ', ' + QUICK_ADD_SELECTOR);

    for (var i = 0; i < elements.length; i++) {
      var data = variantDataOf(elements[i]);
      var entry = data && data[String(variantId)];

      if (!entry) { continue; }

      entry.inCart = toInt(entry.inCart) + Math.max(quantity, 1);
    }

    applyAllStates();
  }

  /**
   * 商品ページのフォーム 1 つ分の状態を、現在の「上限」「カート内数量」から作り直す。
   */
  function applyProductFormState(form) {
    syncSelectedVariant(form);

    var remaining = remainingOf(form);

    if (remaining === null) { return; }

    var reached = remaining === 0;

    // 「今すぐ購入」の非表示はこの属性を見た CSS が行う。
    // theme.min.js は売り切れ時に同じ要素の style.display を直接書くので、こちらは触らない。
    form.setAttribute('data-order-limit-reached', reached ? 'true' : 'false');

    var input = form.querySelector(QUANTITY_INPUT_SELECTOR);

    if (input) {
      // 残り 0 のときは 0 にする。確認モーダルのネイティブ送信はボタンの disabled を
      // 迂回するため、値そのものを通らないようにしておく。
      input.setAttribute('max', String(remaining));

      if (toInt(input.value) > remaining) {
        input.value = String(remaining);
      } else if (remaining > 0 && toInt(input.value) < 1) {
        input.value = '1';
      }
    }

    // 上限の案内。カートが変わってもページは再描画されないので JS で書き換える。
    // カートに入っていないときは個数を出さない（「カートに 0 個」は不自然なため）。
    var note = form.querySelector('[data-order-limit-note]');

    if (note) {
      var inCart = toInt(form.getAttribute('data-order-limit-in-cart'));
      var template = inCart > 0
        ? note.getAttribute('data-order-limit-note-in-cart-template')
        : note.getAttribute('data-order-limit-note-template');

      if (template) {
        note.textContent = template
          .replace('__LIMIT__', String(toInt(form.getAttribute('data-order-limit'))))
          .replace('__IN_CART__', String(inCart));
      }
    }

    var button = form.querySelector('.ProductForm__AddToCart');

    if (!button) { return; }

    var owned = button.getAttribute('data-order-limit-disabled') === 'true';

    if (reached) {
      if (owned || isDisabledByOthers(button)) { return; }

      button.__orderLimitLabel = button.innerHTML;
      button.setAttribute('data-order-limit-disabled', 'true');
      button.setAttribute('disabled', 'disabled');
      button.removeAttribute('data-action');
      button.textContent = limitReachedMessage();
      return;
    }

    if (!owned) { return; }

    // 上限を下回ったので元に戻す。
    // ラベルは、塞いだ時点で控えた内容（= そのバリアントのもの）を優先し、
    // 初期表示から上限到達だった場合は Liquid が出した <template> を種にする。
    var label = button.__orderLimitLabel;

    if (label === undefined) {
      var template = form.querySelector('template[data-order-limit-label]');

      if (!template) { return; } // 売り切れバリアント。誤って有効化しない
      label = template.innerHTML;
    }

    button.innerHTML = label;
    button.removeAttribute('disabled');
    button.setAttribute('data-action', 'add-to-cart');
    button.removeAttribute('data-order-limit-disabled');
    delete button.__orderLimitLabel;
  }

  /**
   * カード（コレクション / LP 一覧）のクイック追加ボタン。
   */
  function applyQuickAddState(quickAdd) {
    syncSelectedVariant(quickAdd);

    var remaining = remainingOf(quickAdd);

    if (remaining === null) { return; }

    var reached = remaining === 0;
    var buttons = quickAdd.querySelectorAll('[type="submit"]');

    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var label = button.querySelector('span:not(.sold-out-message)');
      var owned = button.getAttribute('data-order-limit-disabled') === 'true';

      if (reached) {
        if (owned || isDisabledByOthers(button)) { continue; }

        button.__orderLimitLabel = label ? label.textContent : null;
        button.setAttribute('data-order-limit-disabled', 'true');
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');

        if (label) { label.textContent = limitReachedMessage(); }
        continue;
      }

      if (!owned) { continue; }

      var original = button.__orderLimitLabel;

      if (original === undefined || original === null) {
        original = button.getAttribute('data-order-limit-label');
      }

      if (original === null) { continue; } // 復帰用ラベルが無い（売り切れ）ので触らない

      if (label) { label.textContent = original; }
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
      button.removeAttribute('data-order-limit-disabled');
      delete button.__orderLimitLabel;
    }
  }

  function applyAllStates() {
    var forms = document.querySelectorAll(PRODUCT_FORM_SELECTOR);
    var quickAdds = document.querySelectorAll(QUICK_ADD_SELECTOR);
    var i;

    for (i = 0; i < forms.length; i++) { applyProductFormState(forms[i]); }
    for (i = 0; i < quickAdds.length; i++) { applyQuickAddState(quickAdds[i]); }
  }

  /**
   * /cart.js を読み直して、各要素の data-order-limit-in-cart を実際の値に合わせる。
   * カート操作のたびに呼ばれるので、短時間の連続呼び出しはまとめる。
   * 読めなかった場合は手元の値のまま（次のカート操作でまた読み直す）。
   */
  function refreshInCartQuantities() {
    if (refreshTimer) { clearTimeout(refreshTimer); }

    refreshTimer = setTimeout(function () {
      refreshTimer = null;

      var elements = document.querySelectorAll(PRODUCT_FORM_SELECTOR + ', ' + QUICK_ADD_SELECTOR);

      if (elements.length === 0) { return; }

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) { return; }

          // SKU ごとのカート内数量を作ってから各コンテナへ配る
          var byVariant = {};

          for (var k = 0; k < cart.items.length; k++) {
            var key = String(toInt(cart.items[k].variant_id || cart.items[k].id));
            byVariant[key] = (byVariant[key] || 0) + toInt(cart.items[k].quantity);
          }

          for (var i = 0; i < elements.length; i++) {
            var data = variantDataOf(elements[i]);

            if (!data) { continue; }

            for (var variantId in data) {
              if (!Object.prototype.hasOwnProperty.call(data, variantId)) { continue; }
              data[variantId].inCart = byVariant[variantId] || 0;
            }
          }

          applyAllStates();
        })
        .catch(function () { /* 読めなければ手元の値のまま */ });
    }, 150);
  }

  /**
   * 上限に達している商品のクリックを、カート追加処理より先に止める。
   * theme.min.js は submit ではなく click で Ajax 追加するため click 側で塞ぐ必要がある。
   */
  function onCaptureClick(event) {
    var addToCart = event.target.closest('[data-action="add-to-cart"]');

    if (addToCart && !canAdd(addToCart)) {
      event.preventDefault();
      event.stopPropagation();
      applyAllStates();
      return;
    }

    // 数量の「+」「−」を押したときだけ上限の案内を出す（常時は出さない）
    var quantityButton = event.target.closest('[data-action="increase-quantity"], [data-action="decrease-quantity"]');

    if (quantityButton) {
      var quantityForm = quantityButton.closest(PRODUCT_FORM_SELECTOR);

      if (quantityForm) {
        var quantityNote = quantityForm.querySelector('[data-order-limit-note]');

        if (quantityNote) { quantityNote.style.display = ''; }
      }
    }

    var increase = event.target.closest('[data-action="increase-quantity"]');

    if (!increase) { return; }

    var input = increase.previousElementSibling;

    if (!input || !input.hasAttribute('max')) { return; }

    var max = toInt(input.getAttribute('max'));

    if (toInt(input.value) >= max) {
      if (max <= 0) { input.value = '1'; }
      event.preventDefault();
      event.stopPropagation();
    }
  }

  /**
   * 数量欄が max を超えないようにする。
   * change だけでは足りない（確認モーダルは productForm.submit() を呼ぶため
   * submit イベントも制約検証も走らない）ので、入力のたびにクランプする。
   */
  function onCaptureQuantityEdit(event) {
    var input = event.target;

    if (!input.classList || !input.classList.contains('QuantitySelector__CurrentQuantity')) { return; }
    if (!input.hasAttribute('max')) { return; }

    var max = toInt(input.getAttribute('max'));

    if (toInt(input.value) > max) {
      input.value = String(Math.max(max, 0));
    }
  }

  function onCaptureSubmit(event) {
    var form = event.target;

    if (!form || form.tagName !== 'FORM') { return; }

    var quickAdd = form.closest(QUICK_ADD_SELECTOR);
    var blocked = !canAdd(form);

    // クイック追加の連打よけ。dawn-product-form.js は POST 開始前に aria-disabled を
    // false に戻すので、これが無いと /cart/add が並行して飛ぶ。
    if (!blocked && quickAdd && Date.now() - (quickAdd.__orderLimitLastSubmit || 0) < DOUBLE_SUBMIT_WINDOW) {
      blocked = true;
    }

    if (blocked) {
      event.preventDefault();
      event.stopPropagation();
      applyAllStates();
      return;
    }

    if (quickAdd) { quickAdd.__orderLimitLastSubmit = Date.now(); }
  }

  document.addEventListener('click', onCaptureClick, true);
  document.addEventListener('input', onCaptureQuantityEdit, true);
  document.addEventListener('change', onCaptureQuantityEdit, true);
  document.addEventListener('submit', onCaptureSubmit, true);

  // バリアント変更。カートに追加ボタンが差し替わった直後なので状態を貼り直す。
  // どの SKU に切り替わったかは detail から取る。theme.min.js は隠しセレクトの
  // selected 属性しか書き換えないため、フィールドの値を読むのは当てにならない。
  document.addEventListener('variant:changed', function (event) {
    var detail = event.detail || {};
    var variantId = toInt(detail.variant && detail.variant.id);
    var target = event.target;
    var form = null;

    if (target && target.matches) {
      form = target.matches(PRODUCT_FORM_SELECTOR) ? target : target.querySelector(PRODUCT_FORM_SELECTOR);
    }

    if (form && variantId > 0) { form.__orderLimitVariantId = variantId; }

    applyAllStates();
  });

  // カードのクイック追加は select で SKU を選ぶ。切り替わったら状態を貼り直す。
  document.addEventListener('change', function (event) {
    var field = event.target;

    if (!field || field.name !== 'id' || !field.closest) { return; }

    var container = field.closest(QUICK_ADD_SELECTOR) || field.closest(PRODUCT_FORM_SELECTOR);

    if (!container) { return; }

    container.__orderLimitVariantId = toInt(field.value);
    applyAllStates();
  });

  // カートに追加が成功した直後。theme.min.js は追加数量を detail で渡してくる。
  // /cart.js の応答を待たずに手元の値を進めて、続けて追加されるのを防ぐ。
  document.addEventListener('product:added', function (event) {
    var detail = event.detail || {};
    var variantId = toInt(detail.variant && detail.variant.id);

    if (variantId > 0) { bumpInCart(variantId, toInt(detail.quantity)); }

    refreshInCartQuantities();
  });

  // クイック追加の完了（成否どちらでも。dawn-product-form.js が発火）
  document.addEventListener('order-limit:cart-changed', refreshInCartQuantities);

  // カートドロワーでの数量変更・削除。theme.min.js は専用イベントを出さず
  // Ajax の完了時に theme:loading:end を出すだけなので、これを再取得の契機にする
  document.addEventListener('theme:loading:end', refreshInCartQuantities);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAllStates);
  } else {
    applyAllStates();
  }

  // 確認モーダルのネイティブ送信（productForm.submit()）から呼ばれる送信前チェック。
  // snippets/modal-confirmation-script.liquid が参照する。
  window.orderLimitCanAdd = canAdd;
}());
